<template>
  <div
    class="gap-12 px-4"
    :class="[
      options.length <= 3
        ? 'flex flex-wrap justify-center'
        : theme === THEMES.DJURENS_RATT || theme === THEMES.DEFAULT
          ? 'grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4'
          : 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4',
    ]"
  >
    <template v-for="option in options" :key="option.value">
      <RadioCardRdk
        v-if="theme === THEMES.RDK"
        v-model="modelValueModel"
        :label="option.label"
        :value="option.value"
        :image="option.image"
        :description="option.description"
        :categories="option.categories"
        :tall-cards="tallCards"
        :class="[options.length <= 3 && centeredCardClass]"
      />

      <RadioCardDR
        v-if="theme === THEMES.DJURENS_RATT || theme === THEMES.DEFAULT"
        v-model="modelValueModel"
        :label="option.label"
        :value="option.value"
        :image="option.image"
        :description="option.description"
        :categories="option.categories"
        :tall-cards="tallCards"
        :hideRadio="hideRadio"
        :class="[options.length <= 3 && centeredCardClass]"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core'
import { THEMES } from 'refresh-ui'
import RadioCardRdk from '../atoms/RadioCardRdk.vue'
import RadioCardDR from '../atoms/RadioCardDR.vue'

const props = withDefaults(
  defineProps<{
    options: any
    modelValue: string | number
    tallCards?: boolean
    theme?: THEMES
    hideRadio?: boolean
  }>(),
  {
    theme: THEMES.DEFAULT,
    hideRadio: false,
  },
)

// The cards' own mx-auto would split the row's spare width around each card, pushing a pair far
// apart; drop it so justify-center packs them with just the gap.
const centeredCardClass = 'sm:mx-0 sm:max-w-[346px]'

const emits = defineEmits(['update:modelValue'])
const modelValueModel = useVModel(props, 'modelValue', emits)
</script>
